import { z } from 'zod'

const configSchema = z.object({
    NEXT_PUBLIC_BASE_URL: z.string(),
    NEXT_PUBLIC_CLOUDINARY_URL: z.string(),
    NEXT_PUBLIC_CLOUDINARY_DOMAIN: z.string(),
    NEXT_PUBLIC_API_URL: z.string(),
    NEXT_PUBLIC_PROTOCO: z.enum(['http', 'https']),
    NEXT_PUBLIC_HOST_ENDPOINT: z.string(),
    NODE_ENV: z.enum(['development', 'production']),
    NEXT_PUBLIC_DOMAIN: z.string(),
})

const configProject = configSchema.safeParse({
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_CLOUDINARY_URL: process.env.NEXT_PUBLIC_CLOUDINARY_URL,
    NEXT_PUBLIC_CLOUDINARY_DOMAIN: process.env.NEXT_PUBLIC_CLOUDINARY_DOMAIN,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_PROTOCO: process.env.NEXT_PUBLIC_PROTOCO,
    NEXT_PUBLIC_HOST_ENDPOINT: process.env.NEXT_PUBLIC_HOST_ENDPOINT,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN
})
if (!configProject.success) {
    console.error(configProject.error.issues)
    throw new Error('Các giá trị khai báo trong file .env không hợp lệ')
}

const envConfig = configProject.data
export default envConfig
